import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CheckoutLayout } from 'common/components/layout';
import Footer from 'common/components/layout/Footer';
import { getNextClubPackageByClubId } from 'redux/clubPackages/actions';
import { getClubPackageByClubId } from 'redux/clubPackages/reducers';
import { checkoutStep } from 'redux/clubSignup/actions';
import { getClubBySlug } from 'redux/clubs/reducers';

import EditStep from './EditStep';
import ClubSummary from './components/ClubSummary';
import ContentSummary from './components/ContentSummary';
import Header from './components/Header';
import Message from './components/Message';
import MobileToggleSummary from './components/MobileToggleSummary';
import { calculateStep, editStep } from './helpers';

const Signup = (props) => {
  const { slug } = props;
  const dispatch = useDispatch();

  const [isSummaryVisibleOnMobile, setIsSummaryVisibleOnMobile] =
    useState(false);

  const settingReducer = useSelector((state) => state.setting);
  const clubReducer = useSelector((state) => state.club);
  const clubPackageReducer = useSelector((state) => state.clubPackage);
  const customer = useSelector((state) => state.customer.data);
  const clubSignupReducer = useSelector((state) => state.clubSignup);
  const [step, setStep] = useState('customer');

  const club = getClubBySlug(clubReducer, slug);
  let clubPackage;
  if (club) {
    clubPackage = getClubPackageByClubId(clubPackageReducer, club.id);
  }

  useEffect(() => {
    dispatch(getNextClubPackageByClubId(club.id));
  }, [dispatch, club.id]);

  useEffect(() => {
    if (!clubSignupReducer.isFetching) {
      const newStep = calculateStep(clubSignupReducer);
      setStep(newStep);
    }
  }, [clubSignupReducer]);

  useEffect(() => {
    dispatch(checkoutStep(step));
  }, [dispatch, step]);

  /*
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { props } = this;
    if (!nextProps.clubSignup.isFetching && props.clubSignup.isFetching) {
      const step = calculateStep(nextProps.clubSignup);
      this.setState({ step }, () => {
        if (nextProps.clubSignup.data) {
          props.checkoutStep(step, nextProps.clubSignup.data);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (!prevProps.club && props.club) {
      props.getNextClubPackageByClubId(props.club.id);
    }
  }
    */

  const handleEdit = (stepParam) => {
    const newStep = editStep(clubSignupReducer, stepParam);
    setStep(newStep);
    /*
    if (newStep === 'account' && props.customer.data) {
      this.setState({ step: 'payment' }, () => {
        props.checkoutStep('payment');
      });
    } else {
      this.setState({ step: newStep }, () => {
        props.checkoutStep(newStep);
      });
    }
    */
  };

  const toggleMobileSummary = () => {
    setIsSummaryVisibleOnMobile(!isSummaryVisibleOnMobile);
  };

  // const { settings, customer, club, clubSignup, clubPackage } = this.props;
  // const { isSummaryVisibleOnMobile } = this.state;
  // const { step } = this.state;
  return (
    <CheckoutLayout title="Club Signup">
      <MobileToggleSummary
        onToggleMobile={toggleMobileSummary}
        settings={settingReducer}
      />
      <div className="c7-checkout">
        <ClubSummary
          club={club}
          clubPackage={clubPackage}
          isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
          page="Signup"
          settings={settingReducer}
        />
        <div className="c7-checkout__main">
          <Header
            step={step}
            customer={customer}
            onMenuClick={handleEdit}
            settings={settingReducer}
          />
          <div className="c7-checkout__content">
            <Message settings={settingReducer} />
          </div>
          <ContentSummary
            club={club}
            customer={customer}
            clubSignup={clubSignupReducer.data}
            onEdit={handleEdit}
            currentStep={step}
            settings={settingReducer}
          />
          <EditStep
            clubSignup={clubSignupReducer.data}
            club={club}
            customer={customer}
            step={step}
            onEdit={handleEdit}
          />
          <Footer settings={settingReducer} />
        </div>
      </div>
    </CheckoutLayout>
  );
};

/*
const mapStateToProps = (state, ownProps) => {
  let clubPackage;
  const club = getClubBySlug(state.club, ownProps.slug);
  if (club) {
    clubPackage = getClubPackageByClubId(state.clubPackage, club.id);
  }
  return {
    club,
    clubPackage,
    clubSignup: state.clubSignup,
    customer: state.customer,
    settings: state.setting
  };
};
*/

export default Signup;

/*
export default connect(mapStateToProps, {
  updateClubSignup,
  createClubSignup,
  getNextClubPackageByClubId,
  checkoutStep
})(Signup);
*/
